import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb20d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "modalEl" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Adicionar item", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "O que você vai adicionar?", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Editar item", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "O que você vai alterar?", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { id: "etiquetas" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "quantidade" }, "Quantidade:", -1))
const _hoisted_12 = { class: "multiInputs" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<option value=\"Un.\" title=\"Unidade\" data-v-2bb20d44>Un.</option><option value=\"Kg\" title=\"Quilograma\" data-v-2bb20d44>Kg</option><option value=\"g\" title=\"Grama\" data-v-2bb20d44>g</option><option value=\"L\" title=\"Litro\" data-v-2bb20d44>L</option><option value=\"ml\" title=\"Mililitro\" data-v-2bb20d44>ml</option><option value=\"Oz.\" title=\"Onça\" data-v-2bb20d44>Oz.</option>", 6)
const _hoisted_19 = [
  _hoisted_13
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "preco",
  style: {"width":"150px"}
}, "Preço (R$):", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    (_ctx.modalAction === 'AddItem')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.modalAction === 'EditItem')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.modalAction === 'AddItem' ? _ctx.addItem() : _ctx.editItem()), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          required: "",
          type: "text",
          inputmode: "text",
          placeholder: "Escreva o nome do item...",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemName) = $event))
        }, null, 512), [
          [_vModelText, _ctx.itemName]
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              required: "",
              id: "quantidade",
              inputmode: "numeric",
              type: "number",
              min: "1",
              max: "9999",
              step: "1",
              placeholder: "Ex.: 6",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemQuantity) = $event))
            }, null, 512), [
              [_vModelText, _ctx.itemQuantity]
            ]),
            _withDirectives(_createElementVNode("select", {
              required: "",
              "aria-label": "Selecionar unidade",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemQuantityMetric) = $event))
            }, _hoisted_19, 512), [
              [_vModelSelect, _ctx.itemQuantityMetric]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            id: "preco",
            required: "",
            placeholder: "Ex.: 12,90",
            inputmode: "numeric",
            type: "number",
            min: "0.00",
            max: "999.99",
            step: "0.01",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemPrice) = $event))
          }, null, 512), [
            [_vModelText, _ctx.itemPrice]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          type: "button",
          "aria-label": "Fechar popup",
          disabled: _ctx.addButtonState !== 'Standby',
          "button-text": 'Voltar',
          "has-icon": 'No',
          "button-type": 'Secondary',
          onClick: _ctx.closeDialog
        }, null, 8, ["disabled", "onClick"]),
        (_ctx.modalAction !== 'EditItem')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              "aria-label": "Adicionar item à lista",
              disabled: _ctx.addButtonState !== 'Standby',
              id: "adicionarItem",
              "button-text": _ctx.addButtonState !== 'Loading' ? 'Adicionar' : 'Adicionando...',
              "has-icon": 'No'
            }, null, 8, ["disabled", "button-text"]))
          : _createCommentVNode("", true),
        (_ctx.modalAction === 'EditItem')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              "aria-label": "Editar item da lista",
              disabled: _ctx.addButtonState !== 'Standby',
              id: "editarItem",
              "button-text": _ctx.addButtonState !== 'Loading' ? 'Editar' : 'Salvando...',
              "has-icon": 'No'
            }, null, 8, ["disabled", "button-text"]))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 512))
}